<div class="preview-viewer">
    <!-- <header><h3>PREVIEW   OF <span class="preview-viewer-filename">{{file.name}}</span>  </h3></header> -->
    
    <div class="loader" [hidden]="preview!=null && preview.status_code!=0">
        <div class="dimmed">
            <div class="dimmed_box doble_h"></div>
        </div>
        <!--    <core-helpers-box-loading [hidden]="preview!=null && preview.status_code!=0"></core-helpers-box-loading> -->
    </div>
   

    <core-previews-carousel
        *ngIf="preview!=null && preview.total_pages > 1"
        [preview]="preview"
        (onClickPage)="selectPage($event)"
        [selectedPage]="page"
    ></core-previews-carousel>

    <div class="preview-canvas" [hidden]="preview==null">
        <core-helpers-box-loading [hidden]="preview == null || preview.status_code==0 || imageLoaded"></core-helpers-box-loading>
        <core-preview-page-viewer
            *ngIf="preview!=null && preview.status_code != 0 && preview.status_code != 3 && page > 0"
            [hidden]="!imageLoaded"
            [fileId]="file.id"
            [page]="page"
            [format]="'big-width'"
            (onLoad)="previewLoad($event)"
        ></core-preview-page-viewer>
    </div>
    <div *ngIf="preview!=null && preview.status_code == 3" class="preview-nonexistent">This file has no preview.</div>

</div>
